import { Component, OnInit, OnDestroy, Inject, ViewChild } from "@angular/core";
import { FormBuilder } from "@angular/forms";
import { DateAdapter, MAT_DATE_LOCALE } from "@angular/material/core";
;
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from "@angular/material/dialog";
import { MatPaginator, PageEvent } from "@angular/material/paginator";
import { TranslateService } from "@ngx-translate/core";
import { LayoutUtilsService, LoaderService, RequestService } from "src/app/shared";
import { CaseService } from "src/app/shared/services/case.service";

interface DialogData {
    caseId?: string;
    userId: string;
    title: string;
}

@Component({
    selector: 'app-logs-investigator-dialog',
    templateUrl: './logs-investigator-dialog.component.html',
    styleUrls: ['./logs-investigator-dialog.component.scss']
})
export class LogsInvestigatorMapDialogComponent implements OnInit, OnDestroy {
    public subscriptions: any[] = <any>[];

    public isInvestigator: boolean = false;
    public currentUser: any = undefined;
    public currentUserGroupsId: any[] = [];
    public logsList: any[] = [];

    public pageIndex: number = 1;
    public pageSize: number = 5;
    @ViewChild(MatPaginator) paginator!: MatPaginator;
    constructor(public dialogRef: MatDialogRef<LogsInvestigatorMapDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: DialogData, private loader: LoaderService, private requestService: RequestService, private translate: TranslateService, private layoutUtilsService: LayoutUtilsService, private formBuilder: FormBuilder, private dialog: MatDialog, private caseService: CaseService,
        @Inject(MAT_DATE_LOCALE) public _locale: string, private _adapter: DateAdapter<any>) {
        if (localStorage.getItem('languageSelected')) {
            this._locale = localStorage.getItem('languageSelected');
        } else {
            this._locale = 'en';
        }
        this._adapter.setLocale(this._locale);
    }

    ngOnInit() {
        this.subscriptions.push(
            this.requestService.currentUserSubject.subscribe((data) => {
                if (data) {
                    this.currentUser = data;
                    this.isInvestigator = this.requestService.isUserRoleInvestigator();
                    this.fetchUserLogsData();
                }
            })
        );
    }
    async fetchUserLogsData() {
        if (this.data.userId) {
            this.loader.display(true);
            this.caseService.getCurrentInvestigatorGroups(this.data.userId).then((data: any) => {
                if (data && data.results) {
                    this.currentUserGroupsId = data.results.map(itm => itm._id);
                    this.fetchLogs();

                }
            }).catch((e) => {
                this.loader.display(false);
            });
        }
    }
    ngOnDestroy(): void {
        this.subscriptions.forEach((s) => s.unsubscribe());
    }
    closeModal(): void {
        this.dialogRef.close();
    }
    viewProfile(userId: string) {
        this.caseService.getUserMetadata().then((metadata: any) => {
            this.caseService.viewProfile(userId, metadata);
        });
    }
    viewGroupProfile(groupId: string) {
        this.caseService.getInvestigatorGroupMetadata().then((metadata: any) => {
            this.caseService.viewInvestigatorGroupProfile(groupId, metadata);
        });
    }
    fetchLogs(event?: PageEvent) {
        this.pageIndex = event?.pageIndex || 0;
        this.pageSize = event?.pageSize || 5;
        // let filters = {
        //     type: 'call'
        // };
        // filters["filtervisibility"] = {
        //     userId: this.data.userId,
        //     userGroupsIds: this.currentUserGroupsId,
        //     excludeVisibility: true
        // };

        this.caseService.getCallLogs(this.data.caseId, this.pageIndex, this.pageSize, this.currentUser._id, this.currentUserGroupsId).then((notes: any) => {
            if (notes && notes.results) {
                this.paginator.length = notes.pagination.total;
                this.logsList = notes.results;
            }
        }).finally(() => {
            this.loader.display(false);
        });

        // if (this.data.caseId) {
        //     this.caseService.getTimelinePromise(this.data.caseId, this.pageIndex, this.pageSize, filters).then((notes: any) => {
        //         if (notes && notes.results) {
        //             this.paginator.length = notes.pagination.total;
        //             this.logsList = notes.results;
        //         }
        //     }).finally(() => {
        //         this.loader.display(false);
        //     });
        // } else {
        //     this.caseService.getTimelinePromise(undefined, this.pageIndex, this.pageSize, filters).then((notes: any) => {
        //         if (notes && notes.results) {
        //             this.paginator.length = notes.pagination.total;
        //             this.logsList = notes.results;
        //         }
        //     }).finally(() => {
        //         this.loader.display(false);
        //     });
        // }
    }
}